import { takeLatest, put } from 'redux-saga/effects';
import { StatusUpdatesAPI, StatusUpdateState } from 'api/status-updates';
import { putStatusUpdates } from '../actions';
import { updateStatusUpdate } from '../slice';
function* updateStatusUpdatesManager(action) {
    const { payload } = action;
    try {
        var _payload_statusUpdate;
        if (((_payload_statusUpdate = payload.statusUpdate) === null || _payload_statusUpdate === void 0 ? void 0 : _payload_statusUpdate.state) !== StatusUpdateState.Published || payload.ccUpdate) {
            const response = yield StatusUpdatesAPI.updateStatusUpdate(payload.statusUpdate);
            yield put(updateStatusUpdate(response));
            yield payload.onSuccess && payload.onSuccess(response);
        }
    } catch (unused) {
    // TODO
    }
}
export const watchUpdateStatusUpdates = function*() {
    yield takeLatest(putStatusUpdates.type, updateStatusUpdatesManager);
};
